import { c as _c } from "react/compiler-runtime";
import Translate from "@mui/icons-material/Translate";
import { alpha, Box, Divider, FormControl, InputLabel, List, ListItem, ListItemButton, ListItemIcon, ListItemText, ListSubheader, MenuItem, Select, type SelectChangeEvent, SwipeableDrawer, Typography, useTheme } from "@mui/material";
import { signOut, useSession } from "next-auth/react";
import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";
import type { Locales } from "#/i18n/i18n-types";
import { loadLocaleAsync } from "#/i18n/i18n-util.async";
import { localeLabels, localesForLanguagePicker } from "#/i18n/labels";
import { useI18nContext } from "#/shared/hooks";
import { GITHUB_URL } from "#/constants";
type NavItemProps = {
  title: string;
  onClick?: () => void;
  href?: string;
};
const NavItem: React.FC<NavItemProps> = t0 => {
  const $ = _c(7);
  const {
    title,
    onClick,
    href
  } = t0;
  const component = href ? "a" : "button";
  let t1;
  if ($[0] !== title) {
    t1 = <ListItemText primary={title} />;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== component || $[3] !== href || $[4] !== onClick || $[5] !== t1) {
    t2 = <ListItem disablePadding={true}><ListItemButton component={component} href={href} onClick={onClick}>{t1}</ListItemButton></ListItem>;
    $[2] = component;
    $[3] = href;
    $[4] = onClick;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
type SidePanelProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};
export const SidePanel: React.FC<SidePanelProps> = t0 => {
  const $ = _c(69);
  const {
    isOpen,
    setIsOpen
  } = t0;
  const router = useRouter();
  const {
    LL
  } = useI18nContext();
  const theme = useTheme();
  const session = useSession();
  let t1;
  if ($[0] !== router) {
    t1 = async event => {
      const newLocale = event.target.value as Locales;
      if (newLocale !== router.locale) {
        localStorage.setItem("locale", newLocale);
        await loadLocaleAsync(newLocale);
        router.push(router.asPath, undefined, {
          locale: newLocale
        });
      }
    };
    $[0] = router;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleChangeLocale = t1;
  let t2;
  let t3;
  if ($[2] !== setIsOpen) {
    t2 = () => setIsOpen(true);
    t3 = () => setIsOpen(false);
    $[2] = setIsOpen;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== theme.appDesign.surfaceHigh) {
    t4 = alpha(theme.appDesign.surfaceHigh, 0.88);
    $[5] = theme.appDesign.surfaceHigh;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== theme.appDesign.outline) {
    t5 = alpha(theme.appDesign.outline, 0.16);
    $[7] = theme.appDesign.outline;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = `1px solid ${t5}`;
  let t7;
  if ($[9] !== t4 || $[10] !== t6) {
    t7 = {
      paper: {
        sx: {
          background: t4,
          backdropFilter: "blur(20px)",
          borderLeft: t6
        }
      }
    };
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== LL) {
    t8 = LL.MAIN_MENU();
    $[12] = LL;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <ListSubheader disableSticky={true}>{t8}</ListSubheader>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = `/profile/${session.data?.user.id ?? ""}`;
  let t11;
  if ($[16] !== LL) {
    t11 = LL.PROFILE();
    $[16] = LL;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11) {
    t12 = <NavItem title={t11} />;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t10 || $[21] !== t12) {
    t13 = <Link href={t10}>{t12}</Link>;
    $[20] = t10;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <NavItem title="GitHub" href={GITHUB_URL} />;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== LL) {
    t15 = LL.FEEDBACK();
    $[24] = LL;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t15) {
    t16 = <NavItem title={t15} href={`${GITHUB_URL}/issues`} />;
    $[26] = t15;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== LL) {
    t17 = LL.LOGOUT();
    $[28] = LL;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== t17) {
    t18 = <NavItem title={t17} onClick={_temp} />;
    $[30] = t17;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== t13 || $[33] !== t16 || $[34] !== t18 || $[35] !== t9) {
    t19 = <List subheader={t9}>{t13}{t14}{t16}{t18}</List>;
    $[32] = t13;
    $[33] = t16;
    $[34] = t18;
    $[35] = t9;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Divider />;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  let t21;
  if ($[38] !== LL) {
    t21 = LL.SETTINGS();
    $[38] = LL;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== t21) {
    t22 = <ListSubheader disableSticky={true}>{t21}</ListSubheader>;
    $[40] = t21;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  let t23;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <ListItemIcon><Translate /></ListItemIcon>;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  let t24;
  if ($[43] !== LL) {
    t24 = LL.LANGUAGE();
    $[43] = LL;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  if ($[45] !== t24) {
    t25 = <InputLabel id="side-panel-language-label">{t24}</InputLabel>;
    $[45] = t24;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  let t26;
  if ($[47] !== LL) {
    t26 = LL.LANGUAGE();
    $[47] = LL;
    $[48] = t26;
  } else {
    t26 = $[48];
  }
  const t27 = router.locale as Locales ?? "en";
  let t28;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = localesForLanguagePicker.map(_temp2);
    $[49] = t28;
  } else {
    t28 = $[49];
  }
  let t29;
  if ($[50] !== handleChangeLocale || $[51] !== t26 || $[52] !== t27) {
    t29 = <Select labelId="side-panel-language-label" label={t26} value={t27} onChange={handleChangeLocale}>{t28}</Select>;
    $[50] = handleChangeLocale;
    $[51] = t26;
    $[52] = t27;
    $[53] = t29;
  } else {
    t29 = $[53];
  }
  let t30;
  if ($[54] !== t25 || $[55] !== t29) {
    t30 = <ListItem>{t23}<FormControl fullWidth={true}>{t25}{t29}</FormControl></ListItem>;
    $[54] = t25;
    $[55] = t29;
    $[56] = t30;
  } else {
    t30 = $[56];
  }
  let t31;
  if ($[57] !== t22 || $[58] !== t30) {
    t31 = <List subheader={t22}>{t30}</List>;
    $[57] = t22;
    $[58] = t30;
    $[59] = t31;
  } else {
    t31 = $[59];
  }
  let t32;
  if ($[60] !== t19 || $[61] !== t31) {
    t32 = <Box role="presentation" minWidth="22vw">{t19}{t20}{t31}</Box>;
    $[60] = t19;
    $[61] = t31;
    $[62] = t32;
  } else {
    t32 = $[62];
  }
  let t33;
  if ($[63] !== isOpen || $[64] !== t2 || $[65] !== t3 || $[66] !== t32 || $[67] !== t7) {
    t33 = <SwipeableDrawer anchor="right" open={isOpen} onOpen={t2} onClose={t3} slotProps={t7}>{t32}</SwipeableDrawer>;
    $[63] = isOpen;
    $[64] = t2;
    $[65] = t3;
    $[66] = t32;
    $[67] = t7;
    $[68] = t33;
  } else {
    t33 = $[68];
  }
  return t33;
};
function _temp() {
  return signOut();
}
function _temp2(locale) {
  return <MenuItem key={locale} value={locale}><Typography>{localeLabels[locale]}</Typography></MenuItem>;
}